"use strict";
import React, { cloneElement, Children, Component, createRef } from "react";
import classNames from "classnames";
import ReactResizeDetector from "react-resize-detector/build/withPolyfill";
import { withTabs } from "./Tabs";
export var TabListAlign = /* @__PURE__ */ ((TabListAlign2) => {
  TabListAlign2["Start"] = "start";
  TabListAlign2["Center"] = "center";
  TabListAlign2["End"] = "end";
  return TabListAlign2;
})(TabListAlign || {});
class TabList extends Component {
  constructor() {
    super(...arguments);
    this.tabListRef = createRef();
    this.getIndicatorRect = () => {
      var _a, _b;
      const { selectedIndex, tabRefs } = this.props.tabs;
      const tabListRect = (_a = this.tabListRef.current) == null ? void 0 : _a.getBoundingClientRect();
      const selected = selectedIndex != null ? tabRefs[selectedIndex] : void 0;
      const selectedTabRect = (_b = selected == null ? void 0 : selected.current) == null ? void 0 : _b.getBoundingClientRect();
      const selectedTabRectLeft = selectedTabRect ? selectedTabRect.left : 0;
      const tabListScrollLeft = this.tabListRef.current ? this.tabListRef.current.scrollLeft : 0;
      const tabListRectLeft = tabListRect ? tabListRect.left : 0;
      const left = selectedTabRectLeft + tabListScrollLeft - tabListRectLeft;
      const width = (selectedTabRect == null ? void 0 : selectedTabRect.width) || 0;
      return { left, width };
    };
    this.updateIndicator = () => {
      const indicatorRect = this.getIndicatorRect();
      this.props.tabs.setIndicator(indicatorRect);
    };
    this.handleKeyDown = (event) => {
      var _a, _b, _c, _d;
      const { selectedIndex, setSelectedIndex, tabRefs, focusPanel } = this.props.tabs;
      const numTabs = tabRefs.length;
      switch (event.key) {
        case "ArrowRight":
          const nextIndex = selectedIndex != null ? (selectedIndex + 1) % numTabs : 0;
          (_a = tabRefs[nextIndex].current) == null ? void 0 : _a.focus();
          setSelectedIndex(nextIndex);
          break;
        case "ArrowLeft":
          const prevIndex = selectedIndex != null ? (selectedIndex - 1 + numTabs) % numTabs : 0;
          (_b = tabRefs[prevIndex].current) == null ? void 0 : _b.focus();
          setSelectedIndex(prevIndex);
          break;
        case "End":
          const lastIndex = numTabs - 1;
          (_c = tabRefs[lastIndex].current) == null ? void 0 : _c.focus();
          setSelectedIndex(lastIndex);
          break;
        case "Home":
          (_d = tabRefs[0].current) == null ? void 0 : _d.focus();
          setSelectedIndex(0);
          break;
        case "ArrowDown":
          event.preventDefault();
          focusPanel();
          break;
      }
    };
  }
  componentDidMount() {
    this.updateIndicator();
  }
  componentDidUpdate(prevProps) {
    const numTabsChanged = this.props.tabs.tabRefs.length !== prevProps.tabs.tabRefs.length;
    const indexChanged = this.props.tabs.selectedIndex !== prevProps.tabs.selectedIndex;
    if (numTabsChanged || indexChanged) {
      this.updateIndicator();
    }
  }
  render() {
    const { isBordered, align, className, children, tabs, "aria-label": ariaLabel } = this.props;
    const { indicator } = tabs;
    const currentIndicator = (indicator == null ? void 0 : indicator.width) ? indicator : this.getIndicatorRect();
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        className: classNames("tabs__tab-list", className, {
          "tabs__tab-list--bordered": isBordered
        })
      },
      /* @__PURE__ */ React.createElement("div", { className: "tabs__tab-list-inner", ref: this.tabListRef, onKeyDown: this.handleKeyDown }, /* @__PURE__ */ React.createElement(ReactResizeDetector, { handleWidth: true, onResize: this.updateIndicator }), !!(currentIndicator == null ? void 0 : currentIndicator.width) && /* @__PURE__ */ React.createElement(
        "div",
        {
          className: "tabs__indicator",
          style: {
            transform: `translate3d(${currentIndicator == null ? void 0 : currentIndicator.left}px, 0, 0)`,
            width: currentIndicator == null ? void 0 : currentIndicator.width
          }
        }
      ), /* @__PURE__ */ React.createElement(
        "div",
        {
          className: `tabs__tab-list-items tabs__tab-list-items--align-${align}`,
          role: "tablist",
          "aria-orientation": "horizontal",
          "aria-label": ariaLabel
        },
        /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(ReactResizeDetector, { handleWidth: true, onResize: this.updateIndicator }), Children.toArray(children).filter(Boolean).map((child, index) => cloneElement(child, { index })))
      ))
    );
  }
}
TabList.defaultProps = {
  align: "start" /* Start */
};
export default withTabs(TabList);
